import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Sun = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 28C15.448 28 15 27.552 15 27V25C15 24.448 15.448 24 16 24C16.552 24 17 24.448 17 25V27C17 27.552 16.552 28 16 28Z" />
		<path d="M25.707 24.293C25.888 24.474 26 24.724 26 25C26 25.552 25.552 26 25 26C24.724 26 24.474 25.888 24.293 25.707L22.293 23.707C22.112 23.526 22 23.276 22 23C22 22.448 22.448 22 23 22C23.276 22 23.526 22.112 23.707 22.293L25.707 24.293Z" />
		<path d="M7.707 25.707C7.526 25.888 7.276 26 7 26C6.448 26 6 25.552 6 25C6 24.724 6.112 24.474 6.293 24.293L8.293 22.293C8.474 22.112 8.724 22 9 22C9.552 22 10 22.448 10 23C10 23.276 9.888 23.526 9.707 23.707L7.707 25.707V25.707Z" />
		<path d="M27 17H25C24.448 17 24 16.552 24 16C24 15.448 24.448 15 25 15H27C27.552 15 28 15.448 28 16C28 16.552 27.552 17 27 17Z" />
		<path d="M7 17H5C4.448 17 4 16.552 4 16C4 15.448 4.448 15 5 15H7C7.552 15 8 15.448 8 16C8 16.552 7.552 17 7 17Z" />
		<path d="M16 22C12.691 22 10 19.308 10 16C10 12.692 12.691 10 16 10C19.309 10 22 12.692 22 16C22 19.308 19.308 22 16 22ZM16 12C13.794 12 12 13.794 12 16C12 18.206 13.794 20 16 20C18.206 20 20 18.206 20 16C20 13.794 18.206 12 16 12Z" />
		<path d="M24.293 6.293C24.474 6.112 24.724 6 25 6C25.552 6 26 6.448 26 7C26 7.276 25.888 7.526 25.707 7.707L23.707 9.707C23.526 9.888 23.276 10 23 10C22.448 10 22 9.552 22 9C22 8.724 22.112 8.474 22.293 8.293L24.293 6.293V6.293Z" />
		<path d="M6.293 7.707C6.112 7.526 6 7.276 6 7C6 6.448 6.448 6 7 6C7.276 6 7.526 6.112 7.707 6.293L9.707 8.293C9.888 8.474 10 8.724 10 9C10 9.552 9.552 10 9 10C8.724 10 8.474 9.888 8.293 9.707L6.293 7.707V7.707Z" />
		<path d="M16 8C15.448 8 15 7.552 15 7V4.875C15 4.323 15.448 3.875 16 3.875C16.552 3.875 17 4.323 17 4.875V7C17 7.552 16.552 8 16 8Z" />
	</svg>
);

export default Sun;
